import { render, staticRenderFns } from "./DeletePostPayment.vue?vue&type=template&id=10579d63&"
import script from "./DeletePostPayment.vue?vue&type=script&lang=js&"
export * from "./DeletePostPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports